import React from 'react';
import {WorkSignifier} from '@forecast-it/design-system';
import type {AgentRecord} from './agentDeclaration';

// Joins the parts of the keys the agent components compose.
export const KEY_SEPARATOR = '#';

const recordKey = (recordIndex: number, record: AgentRecord): string => `${recordIndex}${KEY_SEPARATOR}${record.label}`;

// The records a result names, as the panel and the past runs show them.
export const AgentRecordSignifiers = ({records}: {records: AgentRecord[]}): JSX.Element => (
	<>
		{records.map((record, recordIndex) => (
			<WorkSignifier key={recordKey(recordIndex, record)} workId={record.label} name={record.name} color={record.color} />
		))}
	</>
);
